<div style="margin-top: 20px; margin-left: 20px;">
  <form [formGroup]="form">
    <div class="mb-3 row" [ngClass]="{'has-error':!name.valid}">
      <span class="col-lg-2">Name:</span>
      <div class="col-lg-7">
        <input class="form-control" type="text" [formControl]="name" />
      </div>
      @if (name.hasError('required')) {
        <div class="col-lg-3 alert alert-danger"
          style="padding: 5px; margin-bottom: 0px;">
          Name is required
        </div>
      }
    </div>
    @if (!create) {
      <div class="mb-3 row">
        <span class="col-lg-2">API Key:</span>
        <div class="col-lg-7">
          <input class="form-control" type="text" readonly [formControl]="guid" />
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!active.valid}">
      <div class="col-lg-5">
        <input type="checkbox" [formControl]="active" />
        <span class="uv-checkbox-label">Active</span>
      </div>
    </div>
    @if (!create) {
      <div class="mb-3 row">
        <span class="col-lg-2">Last Activity:</span>
        <div class="col-lg-7">
          <input class="form-control" type="text" readonly [formControl]="lastActivity" />
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!clientIpScope.valid}">
      <div class="col-lg-9">
        <label>Client IP Restrictions</label>
        <br/>
        <div>
          <textarea rows="6" cols="50" class="form-control" [formControl]="clientIpScope"></textarea>
        </div>
      </div>
    </div>
  </form>
</div>
